import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import { useIntl } from "gatsby-plugin-react-intl"
import "./blockHighlight.scss"
import Title from "../title"
import Heading from "../heading";
import { graphql, Link } from "gatsby"
import Media from "../media"
import {generateUrlByLocale} from "../../../services/intl.service"
import Slider from "react-slick"

const BlockHighlights = ({ content }) => {
    const intl = useIntl()

    const settings = {
        infinite: false,
        useTransform: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        arrows: true,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: "20px",
                },
            },
        ],
    }

    const itemArticles = content.relationships.block_highlights_2_articles
    const listItemArticles = itemArticles.map((item, index) => (
        <div key={index}>
            <div className="blk-key blk-room-slide">
                <div className="sectionImage animImgRight">
                    {item.relationships.featured_media_landscape?.relationships
                        .featured_media_media && (
                        <Media
                            media={
                                item.relationships.featured_media_landscape.relationships
                                    .featured_media_media
                            }
                        />
                    )}
                </div>
                <div className="blk-key-infos justify-content-left alignLeft">
                    {/*<Title size={2} extraClass="primaryCol" text={item.title} />*/}
                    <Heading
                        heading={3}
                        caption={item.relationships.introduction.introduction_caption}
                        title={item.relationships.introduction.introduction_title}
                    />
                </div>
                <Link
                    to={generateUrlByLocale(item.path.langcode, item.path.alias)}
                    className="hiddenLink"
                ></Link>
            </div>
        </div>
    ))

    return (
        <div className="blk-highlights blk-spacing">
            <Container>
                <Row>
                    <Col md={6} xs={12}>
                        <Title
                            text={content.block_highlights_2_title}
                        />
                    </Col>
                </Row>
                <Row>
                    <Slider {...settings} className="pt-50">
                        {listItemArticles}
                    </Slider>
                </Row>
            </Container>
        </div>
    )
}

export const query = graphql`
  fragment blockHighlights on paragraph__block_highlights_2 {
    internal {
      type
    }
    block_highlights_2_title
    relationships {
      block_highlights_2_articles {
        ... on node__activity {
          title
          path {
            alias
            langcode
          }
          relationships {
            featured_media_portrait: activity_featured_portrait {
              ...getFeaturedMedia
            }
            featured_media_landscape: activity_featured_landscape {
              ...getFeaturedMedia
            }
            introduction: activity_introduction {
              introduction_title
              introduction_caption
              introduction_description {
                processed
              }
            }
          }
        }
      }
    }
  }
`

export default BlockHighlights